import { dismissError } from '@/actions/metaActions';
import { stateErrors } from '@/selectors/selectors';
import { VegkartError } from '@/state';
import { useDispatch, useSelector } from '@/state/store';
import { useCallback, useRef } from 'react';
import { ErrorContainer } from './ErrorContainer';

const Errors = () => {
    const dispatch = useDispatch();
    const errors = useSelector(stateErrors);
    const dismiss = useCallback(
        (e: VegkartError) => dispatch(dismissError(e)),
        [dispatch]
    );
    const popoverRef = useRef<HTMLDivElement>(null);
    popoverRef.current?.togglePopover(errors.length > 0);

    return (
        <div className="c-errors" popover="manual" ref={popoverRef}>
            {errors.map(e => (
                <ErrorContainer error={e} key={e.uuid} dismiss={dismiss} />
            ))}
        </div>
    );
};
export default Errors;
